import { ContentProps } from '@helper/util/landing/types'

import Container from '@/landing/component/container'
import Heading from '@/landing/component/heading'

import FaQ from '@/landing/template/faq/Contents'

type Props = {
    contents: ContentProps;
    language: string;
}

const Landing = ({ contents, language }:Props) => {
  const { faqLabel, faqCaption } = contents
  return (
        <Container>
            <Heading caption={faqCaption} label={faqLabel} />
            <FaQ language={language} />
        </Container>
  )
}

export default Landing
